import {AfterViewInit, Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-insert-pdf',
  templateUrl: './insert-pdf.component.html',
  styleUrls: ['./insert-pdf.component.scss']
})
export class InsertPdfComponent implements OnInit, AfterViewInit {
  @Input() benefitData: any;
  benefitPdfForm: FormGroup;
  fileImg64: any;
  wrongSize: any;

  // example
  img: any;
  img64: any;
  imgUpload = false;

  constructor(
    private fb: FormBuilder,
    private serviceModal: NgbActiveModal,
  ) {
  }

  ngOnInit(): void {
    this.createForm();
  }

  ngAfterViewInit(): void {
    if (this.benefitData) {
      this.updateForm();
    }
  }

  private createForm(): any {
    if (this.benefitData) {
      this.benefitPdfForm = this.fb.group({
        pdf: ['', Validators.required],
        pdf64: [''],
        pdf64Upload: [false],
        id: [0],
      });
    } else {
      this.benefitPdfForm = this.fb.group({
        pdf: ['', Validators.required],
        pdf64: [''],
        pdf64Upload: [false],
      });
    }
  }

  private updateForm(): any {
    this.benefitPdfForm.get('id').setValue(this.benefitData);
  }

  sendData(): any {
    this.serviceModal.close(this.benefitPdfForm.value);
  }


  getBase64(event): void {
    const reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = (e) => {
      this.benefitPdfForm.get('pdf').setValue((event.target.files[0]).name);
      if (typeof e.target.result === 'string') {
        this.benefitPdfForm.get('pdf64').setValue(e.target.result.split(',')[1]);
      }
      this.benefitPdfForm.get('pdf64Upload').setValue(true);
    };
  }

}
